import { render, staticRenderFns } from "./ChatProgress.vue?vue&type=template&id=56690a83&scoped=true&"
import script from "./ChatProgress.vue?vue&type=script&lang=js&"
export * from "./ChatProgress.vue?vue&type=script&lang=js&"
import style0 from "./ChatProgress.vue?vue&type=style&index=0&id=56690a83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56690a83",
  null
  
)

export default component.exports